import React from "react";
import { Index } from "../components/Reinsurance/Index";

export const Reinsurance = () => {
  return <Index />;
};
